// @flow

import React, { Component } from 'react';
import Slider from '../../../slider';
import type { Slide } from '../../types';
import {
  GallerySliderContainer,
  GallerySlide,
  GalleryLink,
  ImageThumb,
  VideoThumb,
} from './atoms';
import { breakpointsPx } from '../../../../helpers/breakpoints';

type Props = {|
  slides: Array<Slide>,
  selectedSlideId: string,
  onSelectImage: Function,
  galleryId: number,
|};

type State = {|
  didMount: boolean,
|};

class GalleryNavigation extends Component<Props, State> {
  constructor() {
    super();
    this.state = {
      didMount: false,
    };
  }

  componentDidMount = () => {
    this.setState({ // eslint-disable-line react/no-did-mount-set-state
      didMount: true,
    });
  }

  render() {
    const {
      slides, selectedSlideId, onSelectImage, galleryId,
    } = this.props;
    const { didMount } = this.state;

    return (
      <GallerySliderContainer>
        <Slider
          arrowNavigation
          bulletNavigation={false}
          totalSlides={slides.length}
          perPage={{
            [breakpointsPx.md]: 3.5,
            '0': 2.5, // eslint-disable-line
          }}
        >
          {slides.map((slide, index) => (
            <GalleryLink
              key={`${slide.id}`}
              role="button"
              tabIndex={index}
              onClick={() => onSelectImage(slide.id)}
            >
              {didMount && (
                <GallerySlide
                  galleryId={galleryId}
                  slideId={slide.id}
                  selectedSlideId={selectedSlideId}
                >
                  {slide.type === 'image'
                    && <ImageThumb {...slide.props} />}
                  {slide.type === 'video'
                    && <VideoThumb {...slide.props} />}
                </GallerySlide>
              )}
            </GalleryLink>
          ))}
        </Slider>
      </GallerySliderContainer>
    );
  }
}


export default GalleryNavigation;
